import { Text } from "@/atoms";
import { useTranslation } from "@/core/i18n";

type ReferralRewardsStatsCardProps = {
  totalReferred: number;
  totalEarned: number;
  brandColor?: string;
};

export const ReferralRewardsStatsCard = ({
  totalReferred,
  totalEarned,
  brandColor,
}: ReferralRewardsStatsCardProps) => {
  const { t } = useTranslation();
  const rgbBrandColor = brandColor
    ? brandColor
        .replace("#", "")
        .match(/.{2}/g)
        ?.map((hex) => parseInt(hex, 16))
        .join(", ")
    : "123, 135, 194";

  return (
    <div
      className="relative flex h-[160px] w-full overflow-hidden rounded-2xl bg-white shadow-sm"
      style={{
        boxShadow: "0px 0px 1.709px 1.709px rgba(202, 202, 202, 0.25)",
      }}
    >
      <div
        className="pointer-events-none absolute"
        style={{
          width: "267.59px",
          height: "267.59px",
          left: "-93px",
          top: "50%",
          transform: "translateY(-50%) rotate(-2.606deg)",
          borderRadius: "50%",
          background: `linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(${rgbBrandColor}, 1) 100%)`,
          opacity: 0.25,
          filter: "blur(85.71px)",
        }}
      />

      <div
        className="pointer-events-none absolute"
        style={{
          width: "234.87px",
          height: "234.87px",
          right: "-55px",
          top: "50%",
          transform: "translateY(-50%) rotate(-2.606deg)",
          borderRadius: "50%",
          background: `linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(${rgbBrandColor}, 1) 100%)`,
          opacity: 0.25,
          filter: "blur(85.71px)",
        }}
      />

      <div className="relative flex w-full items-center justify-center gap-[38px] px-[54px]">
        <div className="flex flex-col items-center gap-1">
          <div
            className="text-center text-[38px] font-normal leading-[40px] text-black"
            style={{
              fontFamily: "STIX Two Text",
              fontWeight: 440,
            }}
          >
            {totalReferred}
          </div>
          <Text
            variant="body2"
            className="text-center text-sm text-black"
            text={t("referralRewardsStatsCard.totalReferred")}
          />
        </div>

        <div
          className="h-[111px] w-px"
          style={{
            backgroundColor: "rgba(176, 187, 191, 1)",
          }}
        />

        <div className="flex flex-col items-center gap-1">
          <div
            className="text-center text-[38px] font-normal leading-[40px] text-black"
            style={{
              fontFamily: "STIX Two Text",
              fontWeight: 440,
            }}
          >
            ${totalEarned}
          </div>
          <Text
            variant="body2"
            className="text-center text-sm text-black"
            text={t("referralRewardsStatsCard.totalEarned")}
          />
        </div>
      </div>
    </div>
  );
};
